/**
 * Handles mounting React components.
 */
import React from 'react'
import ReactDOM from 'react-dom'
import { nodes } from './dom'
import { warn } from '../application/console'
import { registerUtils } from '../application/nm'
import { create as makeEmptyObj } from './object'
import EmptyComponent from '../organizedByType/components/emptyComponent'

function renderComponentToRootNode(component, rootNode) {
  return ReactDOM.render(component, rootNode)
}

export function mount(opts = {}) {
  const { component, rootSelector } = opts
  const domNodes = nodes(rootSelector)
  if (domNodes && domNodes.length > 0) {
    return Array.from(domNodes, renderComponentToRootNode.part(component))
  }
  return warn(
    `Component '${component.type
      .name}' can't be mounted: '${rootSelector}' selector result is empty!`,
    { opts, component, rootSelector, domNodes }
  )
}

export function unmount(rootNode) {
  return ReactDOM.unmountComponentAtNode(rootNode)
}

export function mountAll(selectorComponentMap = {}) {
  for (const rootSelector in selectorComponentMap) {
    const component = selectorComponentMap[rootSelector]
    mount({ component, rootSelector })
  }
}

export const empty = <EmptyComponent />

const comp = {
  ...makeEmptyObj(),
  mount,
  unmount,
  mountAll,
  empty,
}

registerUtils({ component: comp })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/rComponent.js